<template>
  <div>
    <p class="mb-2.5 text-base font-medium">{{ title }}</p>
    <ul class="space-y-1">
      <li v-for="feature in features" :key="feature" class="flex gap-2">
        <div class="mt-1 w-3.5"><img :src="featureTick" /></div>
        {{ feature }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import featureTick from '@/assets/feature-tick.png';

defineProps<{
  title: string;
  features: string[];
}>();
</script>
